module.exports = __webpack_public_path__ + "4337620b1c2159ef1d3a497d23ee382c.jpg";